import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ExternalUrls } from '../../externalUrls';

interface TenantPlanCheckResult {
  canTakeAction: boolean;
  reason: string;
  callToAction: string;
  displayTitleIcon: boolean;
}

@Component({
  selector: 'app-tenant-plan-error-modal',
  templateUrl: './tenant-plan-error-modal.component.html',
  styleUrls: ['./tenant-plan-error-modal.component.scss'],
})
export class TenantPlanErrorModalComponent {
  readonly externalUrls = ExternalUrls;

  constructor(
    public dialogRef: MatDialogRef<TenantPlanErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TenantPlanCheckResult
  ) {}
}
